export const VOUCHER_PAGE_BREADCRUMBS = [
  {
    title: 'Beranda',
    link: '/',
  },
  {
    title: 'Voucher Management',
    link: '/vouchers',
  },
];

export const VOUCHER_DATE_FILTER_CONFIG = {
  fromField: 'voucher_period-from' as const,
  toField: 'voucher_period-to' as const,
  paramFromName: 'start_date' as const,
  paramToName: 'end_date' as const,
  defaultPeriod: '',
  resetPage: false,
};

export const VOUCHER_TOAST_MESSAGES = {
  deleteSuccess: 'Voucher berhasil dihapus',
  statusUpdateSuccess: 'Status voucher berhasil diperbarui',
  displayUpdateSuccess: 'Pengaturan tampil di SOL berhasil diperbarui',
  moveToTopSuccess: 'Voucher berhasil dipindahkan ke atas',
  moveToTopError: (message: string) => `Gagal memindahkan voucher: ${message}`,
};
